import {useCallback} from 'react';
import {OptionBlock} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/ChuckECheese/components/OptionBlock/OptionBlock';
import {Typography} from '~library/atoms/Typography';

import './JoinTheClub.sass';

type JoinTheClubProps = {
  isActive: boolean;
  onChange: (value: boolean) => void;
};

export const JoinTheClub = ({isActive, onChange}: JoinTheClubProps) => {
  const onChangeHandler = useCallback((value: boolean) => onChange(value), [onChange]);

  return (
    <OptionBlock
      title="Join the Chuck E. Cheese Birthday Club"
      isActive={isActive}
      onToggleClickHandler={onChangeHandler}
      dataQaId="join-the-club"
    >
      <Typography variant="paragraph3" color="pebble">
        It’s completely free and packed with perks! Club members get:
      </Typography>

      <ul className="join-the-club__ul">
        <li>
          <Typography variant="paragraph3" color="pebble">
            30 minutes of free gameplay
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph3" color="pebble">
            500 bonus E-Tickets
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph3" color="pebble">
            Free cotton candy
          </Typography>
        </li>
      </ul>
    </OptionBlock>
  );
};
